import React from 'react'
import { graphql } from 'gatsby'
import { mergePrismicPreviewData } from 'gatsby-source-prismic'
import { SEO, CaseStudiesDetailHero } from 'newComponents'
import * as Slices from '../slices'
import Layout from '../components/layout.js'
import './case_studies.scss'
import OldCtas from '../components/ClosingCTAs'

const IS_BROWSER = typeof window !== 'undefined'

// import { setupPreviewData } from '../utils/setupPreviewData';
export const Slice = ({ data, location }) => {
  const { slice_type: sliceType } = data
  const allSlices = { ...Slices }
  // Convert slice type from snake_case to TitleCase
  if (!sliceType) return null
  let sliceName = sliceType
    .split('_')
    .map((item) => item.charAt(0).toUpperCase() + item.substring(1))
    .join('')

  sliceName === 'CustomerQuote' ? (sliceName = 'BreakoutQuote') : ''

  const CustomSlice = allSlices[sliceName]
  return <CustomSlice data={data} location={location} />
}

const CaseStudiesDetail = ({ data: staticData, location, pageContext }) => {
  // const data = setupPreviewData(staticData);
  const previewData = IS_BROWSER && window.__PRISMIC_PREVIEW_DATA__
  const data = mergePrismicPreviewData({ staticData, previewData })
  const { page } = data
  const { data: pageData, uid } = page

  const { metaTitle, metaDesc, ogImage, body: sliceData, company_name: companyName } = pageData

  // seo data
  const seo = {
    title: metaTitle?.text,
    description: metaDesc?.text,
    ogImage: ogImage?.url
  }

  const hero = {
    title: pageData.headline,
    logo: pageData.logo
  }

  return (
    <Layout>
      <SEO {...seo} />
      <div className="case-studies">
        <CaseStudiesDetailHero contents={hero} />
        <div className="blog-post-slice-content">
          {sliceData.map((slice) => (
            <Slice key={slice.id} data={{ ...slice, uid, companyName }} location={location} />
          ))}
          <div className="closing-ctas-slice old">
            <OldCtas />
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default CaseStudiesDetail

export const caseStudiesQuery = graphql`
  query CaseStudiesBySlug($uid: String!) {
    page: prismicCaseStudies(uid: { eq: $uid }) {
      id
      uid
      prismicId
      data {
        metaTitle: meta_title {
          html
          text
        }
        metaDesc: meta_description {
          html
          text
        }
        ogImage: open_graph_image {
          url
        }
        company_name
        logo {
          url
          localFile {
            childImageSharp {
              fluid(maxWidth: 2000, quality: 90) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
        headline {
          text
          html
        }
        body {
          ...CaseStudyBreakoutQuote
          ...CaseStudiesOverview
          ...CaseStudiesTimeline
        }
      }
    }
  }
`
